<template>
  <tr style="height: 74px">
    <template v-if="innerValue">
      <td class="">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="font-weight-medium">
              {{ goodsTypeDesc }}
              <v-btn @click="$emit('click:edit')" depressed x-small icon class="mt-n1" :disabled="!canChange">
                <v-icon right>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <div class="text--secondary">
              {{ aspectTypeDesc }}
              <span v-if="isExceptionalTransport" class="font-weight-medium orange--text"> TRASPORTO ECCEZIONALE</span>
            </div>
          </div>
        </div>
      </td>
      <td class="text-center px-1">{{ innerValue.weights.onboard || '' }}</td>
      <td class="text-center px-1">
        <v-text-field
          v-model.number="innerValue.weights.loaded"
          outlined
          type="number"
          class="mx-auto ml-3 mb-n6 hide-arrows"
          dense
          :disabled="!canChange"
          v-if="isFilled"
          :min="0"
          :rules="loadedRules"
          style="width: 120px"
          @input="handleChanges"
          @keypress="isNumber($event)"
          suffix=",00"
          persistent-hint
          hint="in quintali"
        >
          <template #append-outer>
            <div class="mt-1 text-no-wrap"><i>q</i></div>
          </template>
        </v-text-field>
      </td>
      <td class="text-center px-1">
        <v-text-field
          v-model.number="innerValue.weights.unloaded"
          outlined
          type="number"
          class="mx-auto ml-3 mb-n6 hide-arrows"
          dense
          :disabled="!canChange"
          v-if="isFilled"
          :min="0"
          :max="maxUnloadableWeight"
          :rules="unloadedRules"
          style="width: 120px"
          @input="handleChanges"
          @keypress="isNumber($event)"
          suffix=",00"
          persistent-hint
          hint="in quintali"
        >
          <template #append-outer>
            <div class="mt-1 text-no-wrap"><i>q</i></div>
          </template>
        </v-text-field>
      </td>
      <td class="text-center">{{ isFilled ? remainingOnboard : '' }}</td>
      <td class="text-right">
        <v-btn icon @click="$emit('click:delete')" small :disabled="!canChange">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </td>
    </template>
  </tr>
</template>

<script>
// Types
import { goodsTypes, cargoTypes, Helper as _ } from '@/types'

// Helpers
import { clone } from '@/helpers'

// Validators
import { required, min, max } from '@/validations'

export default {
  name: 'JourneyFormStandardGoodsTableRow',
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerValue: null,
    }
  },
  created() {
    this.innerValue = clone(this.value)
  },
  watch: {
    value(value) {
      this.innerValue = clone(value)
    },
  },
  computed: {
    isInherited() {
      return this.innerValue.is_inherited
    },
    isClosedSlot() {
      return this.isInherited && this.innerValue.weights.onboard === 0
    },
    isFilled() {
      return !!this.innerValue.type
    },
    isExceptionalTransport() {
      return this.innerValue.weights.loaded > 440
    },
    wasAlreadyOnboard() {
      return this.onboard > 0
    },
    onboardAtDeparture() {
      return this.innerValue.weights.onboard + this.innerValue.weights.loaded
    },
    remainingOnboard() {
      return this.onboardAtDeparture - this.innerValue.weights.unloaded
    },
    maxUnloadableWeight() {
      return this.onboardAtDeparture
    },
    goodsTypeDesc() {
      return _(goodsTypes).getDescById(this.innerValue.type)
    },
    aspectTypeDesc() {
      return _(cargoTypes).getDescById(this.innerValue.aspect)
    },
    // Permessi
    canChange() {
      return !this.isClosedSlot && !this.disabled
    },
    loadedRules() {
      if (this.isInherited) return [required, min(0)]
      return [required, min(1)]
    },
    unloadedRules() {
      return [required, min(0), max(this.maxUnloadableWeight)]
    },
  },
  methods: {
    emitValue() {
      this.innerValue.weights.remaining = this.remainingOnboard
      this.$emit('input', this.innerValue)
    },
    handleChanges() {
      this.innerValue.weights.remaining = this.remainingOnboard
      this.$emit('input', this.innerValue)
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .hide-arrows {
  input[type='number'] {
    text-align: right;
    font-weight: bold;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
